/*
 * Created by jmeo at 2021-05-11
 * FileName: request.ts
 */

import axios, {AxiosRequestConfig} from 'axios'
import {isEmpty} from "@util/index";

const request = axios.create()

function get<T>(uri: string, params?: any) {
  return request.get(uri, {params: params}).then((rs) => {
    const _data = rs.data || {}
    const {errcode, errmsg, data} = _data
    if (errcode != 0) {
      throw errmsg
    }
    return data as T
  })
}

function post<T>(uri: string, data?: any, config?: AxiosRequestConfig) {
  const form = new FormData()
  if (data) {
    for (const k in data) {
      if (!isEmpty(data[k])) {
        form.append(k, data[k])
      }
    }
  }
  return request
      .post(uri, form, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        ...config,
      })
      .then((rs) => {
        const _data = rs.data || {}
        const {errcode, errmsg, data} = _data
        if (errcode != 0) {
          throw errmsg
        }
        return data as T
      })
}

function normalPost<T>(uri: string, data?: any, config?: AxiosRequestConfig) {
  return request
      .post(uri, data, {
        headers: {'Content-Type': 'application/json'},
        ...config,
      })
      .then((rs) => {
        const _data = rs.data || {}
        const {errcode, errmsg, data} = _data
        if (errcode != 0) {
          throw errmsg
        }
        return data as T
      })
}

export default {
  post,
  get,
  normalPost,
  axios
}
